class ProductInstallmentOptions extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Escuchar cambios en el precio del producto
    this.listenForPriceChanges();
  }

  listenForPriceChanges() {
    // Escuchar eventos de cambio de variante
    document.addEventListener('variant:change', (event) => {
      this.updateInstallmentPrice(event.detail.variant);
    });

    // Escuchar cambios en el precio (para compatibilidad con otros scripts)
    document.addEventListener('price:change', (event) => {
      this.updateInstallmentPrice(event.detail);
    });
  }

  updateInstallmentPrice(variant) {
    if (!variant || !variant.price) return;

    const installmentElement = this.querySelector('.installment-option');
    if (!installmentElement) return;

    // Obtener configuración del theme
    const installments = parseInt(this.dataset.installments) || 6;
    const interestFree = this.dataset.interestFree === 'true';
    
    // Calcular precio por cuota
    const pricePerInstallment = variant.price / installments;
    
    // Formatear precio en pesos argentinos
    const formattedPrice = this.formatPrice(pricePerInstallment);
    
    // Actualizar texto
    const interestText = interestFree ? ' sin interes' : '';
    installmentElement.textContent = `${installments} cuotas de ${formattedPrice}${interestText}`;
  }

  formatPrice(price) {
    // Formatear precio para pesos argentinos
    const formatter = new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    
    return formatter.format(price);
  }
}

// Registrar el custom element
customElements.define('product-installment-options', ProductInstallmentOptions);
